// ─── MISC STANDALONE CONSTANTS ───────────────────────────────────────────────
export const NOTIF_GRACE_MS = 3 * 60 * 1000; // catch reminders up to 3 min "late" (poll interval + brief backgrounding)

// Reminders (tasks/events) fire as one of two alert types:
// - "notification": always plays this one fixed sound, no choice offered.
// - "alarm": user picks from ALARM_SOUND_OPTIONS below.
export const NOTIFICATION_SOUND_FILE = "/notify.mp3";
export const ALARM_SOUND_OPTIONS = [
  { id: "silverPulse",       label: "Silver Pulse",         file: "/sounds/silver-pulse.mp3" },
  { id: "softBells",         label: "Soft Bells",           file: "/sounds/soft-bells.mp3" },
  { id: "acousticGuitar",    label: "Acoustic Guitar",      file: "/sounds/acoustic-guitar.mp3" },
  { id: "warmTone",          label: "Warm Tone",            file: "/sounds/warm-tone.mp3" },
  { id: "beijingHarmony",    label: "Beijing Harmony",      file: "/sounds/beijing-harmony.mp3" },
  { id: "energeticPop",      label: "Energetic Pop",        file: "/sounds/energetic-pop.mp3" },
  { id: "meteorGarden",      label: "Meteor Garden",        file: "/sounds/meteor-garden.mp3" },
  { id: "petalsOnTheWater",  label: "Petals on the Water",  file: "/sounds/petals-on-the-water.mp3" },
  { id: "softLofi",          label: "Soft Lofi",            file: "/sounds/soft-lofi.mp3" },
  { id: "kalimba",           label: "Kalimba",              file: "/sounds/kalimba.mp3" },
];
export const DEFAULT_ALARM_SOUND = "silverPulse";

// Focus/Pomodoro timer completion — one fixed sound, no picker. Used as the
// web-only one-shot fallback (plain <audio>, see FocusTab.jsx). On Android,
// the Clock-In countdown's completion alarm now rings via the system Clock
// app's own default alarm sound (see src/capacitor/timerAlarm.js) rather
// than a Clarity-built ringtone, so CLOCK_IN_ALARM_SOUND_ID is no longer
// wired to anything native — kept only in case a native ringtone path comes
// back.
export const TIMER_ALARM_SOUND_FILE = "/sounds/clockin-timer-alarm.mp3";
export const CLOCK_IN_ALARM_SOUND_ID = "clockInDone";

// For the donut chart specifically — "Other" always gets muted gray
export const OTHER_COLOR = "hsl(300, 12%, 82%)";

// ── Link categories ──────────────────────────────────────────────────────────
export const LINK_CATS = [
  { key: "meeting",  emoji: "🎥", label: "Online Meeting",  placeholder: "Zoom / Meet / Teams link…" },
  { key: "location", emoji: "📍", label: "Location",        placeholder: "Google Maps / Waze link…" },
  { key: "work",     emoji: "💼", label: "Work / Project",  placeholder: "Notion / GitHub / Figma link…" },
  { key: "video",    emoji: "📺", label: "Video / Stream",  placeholder: "YouTube / Spotify link…" },
  { key: "other",    emoji: "🔗", label: "Other",           placeholder: "Paste any link…" },
];
